import {
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  IconButtonProps,
  List,
} from '@material-ui/core'
import { Edit } from '@material-ui/icons'
import React, { ReactNode } from 'react'

interface StandardCardContentProps {
  children: any
  section?: {
    header?: {
      title?: ReactNode
      onClickAction?: (event: React.MouseEvent<HTMLButtonElement>) => void
      icon?: any
      disabled?: boolean
    }
    footer?: {
      onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
      label?: string
    }
  }
}

export default function StandardCardContent(props: StandardCardContentProps) {
  const { children, section } = props

  return (
    <div className="card-form">
      <Card>
        {section?.header && (
          <CardHeader
            disableTypography
            title={
              <List className="core-list" disablePadding>
                {section?.header?.title}
              </List>
            }
            action={
              <IconButton
                disabled={section?.header?.disabled}
                className="card-header-btn"
                aria-label="edit"
                onClick={section?.header?.onClickAction}
              >
                {section?.header?.icon}
              </IconButton>
            }
          />
        )}

        <CardContent>{children}</CardContent>
      </Card>
      {section?.footer && (
        <div className="btn-container">
          <Button
            color="primary"
            variant="contained"
            onClick={section?.footer?.onClick}
          >
            {section?.footer?.label}
          </Button>
        </div>
      )}
    </div>
  )
}
